export default [
    {
        name: 'w1d1badge1',
        week: 1,
        day: 1,
        game: [1, 1, 3],
        title: {
            w: {
                de: 'Echte Heldin',
                en: 'True hero'
            },
            m: {
                de: 'Echter Held',
                en: 'True hero'
            }
        }
    },
    {
        name: 'w1d2badge1',
        week: 1,
        day: 2,
        game: [1, 2, 5],
        title: {
            w: {
                de: 'Zahlenheldin',
                en: 'Numbers hero'
            },
            m: {
                de: 'Zahlenheld',
                en: 'Numbers hero'
            }
        }
    },
    {
        name: 'w1d3badge1',
        week: 1,
        day: 3,
        game: [1, 3, 1],
        title: {
            w: {
                de: 'Tolle Chemikerin',
                en: 'Great chemist'
            },
            m: {
                de: 'Toller Chemiker',
                en: 'Great chemist'
            }
        }
    },
    {
        name: 'w1d3badge2',
        week: 1,
        day: 3,
        game: [1, 3, 3],
        title: {
            w: {
                de: 'Neugierige Geologin',
                en: 'Curious geologist'
            },
            m: {
                de: 'Neugieriger Geologe',
                en: 'Curious geologist'
            }
        }
    },
    {
        name: 'w1d4badge1',
        week: 1,
        day: 4,
        game: [1, 4, 2],
        title: {
            w: {
                de: 'Ingenieurin',
                en: 'Engineer'
            },
            m: {
                de: 'Ingenieur',
                en: 'Engineet'
            }
        }
    },
    {
        name: 'w2d2badge1',
        week: 2,
        day: 2,
        game: [2, 2, 1],
        title: {
            w: {
                de: 'Medizintechnikerin',
                en: 'Medical technician'
            },
            m: {
                de: 'Medizintechniker',
                en: 'Medical technician'
            }
        }
    },
    {
        name: 'w2d3badge1',
        week: 2,
        day: 3,
        game: [2, 3, 3],
        title: {
            w: {
                de: 'Elektrotechnikerin',
                en: 'Electric technician'
            },
            m: {
                de: 'Elektrotechniker',
                en: 'Electric technician'
            }
        }
    },
    {
        name: 'w2d4badge1',
        week: 2,
        day: 4,
        game: [2, 4, 3],
        title: {
            w: {
                de: 'Roboterspezialistin',
                en: 'Robot specialist'
            },
            m: {
                de: 'Roboterspezialist',
                en: 'Robot specialist'
            }
        }
    },
    {
        name: 'w3d1badge1',
        week: 3,
        day: 1,
        game: [3, 1, 3],
        title: {
            w: {
                de: 'Bahningenieurin',
                en: 'Train engineer'
            },
            m: {
                de: 'Bahningenieur',
                en: 'Train engineer'
            }
        }
    },
    {
        name: 'w3d2badge1',
        week: 3,
        day: 2,
        game: [3, 2, 3],
        title: {
            w: {
                de: 'Elektromechanikerin',
                en: 'Electrician'
            },
            m: {
                de: 'Elektromechaniker',
                en: 'Electrician'
            }
        }
    },
    {
        name: 'w3d3badge1',
        week: 3,
        day: 3,
        game: [3, 3, 6],
        title: {
            w: {
                de: 'Netzwerkspezialistin',
                en: 'Power grid specialist'
            },
            m: {
                de: 'Netzwerkspezialist',
                en: 'Power grid specialist'
            }
        }
    },
    {
        name: 'w3d4badge1',
        week: 3,
        day: 4,
        game: [3, 4, 4],
        title: {
            w: {
                de: 'Energieberaterin',
                en: 'Energy consultant'
            },
            m: {
                de: 'Energieberater',
                en: 'Energy consultant'
            }
        }
    },
    {
        name: 'w4d1badge1',
        week: 4,
        day: 1,
        game: [4, 1, 2],
        title: {
            w: {
                de: 'Trainerin',
                en: 'Coach'
            },
            m: {
                de: 'Trainer',
                en: 'Coach'
            }
        }
    },
    {
        name: 'w4d2badge1',
        week: 4,
        day: 2,
        game: [4, 2, 2],
        title: {
            w: {
                de: 'Datenexpertin',
                en: 'Data expert'
            },
            m: {
                de: 'Datenexperte',
                en: 'Data expert'
            }
        }
    },
    {
        name: 'w4d3badge1',
        week: 4,
        day: 3,
        game: [4, 3, 2],
        title: {
            w: {
                de: 'Aktives Mädchen',
                en: 'Active girl'
            },
            m: {
                de: 'Aktiver Junge',
                en: 'Active boy'
            }
        }
    },
    {
        name: 'w4d4badge1',
        week: 4,
        day: 4,
        game: [4, 4, 4],
        title: {
            w: {
                de: 'Staffelheldin',
                en: 'Relay hero'
            },
            m: {
                de: 'Staffelheld',
                en: 'Relay hero'
            }
        }
    }
];
